<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="requestSource" label="来源系统">
              <a-select
                v-model:value="queryForm.requestSource"
                placeholder="请选择"
                allow-clear
                :options="requestSourceEnum"
              />
            </dc-form-item>
            <dc-form-item label="创建时间">
              <cos-range-picker
                style="width: 100%"
                v-model:startTime="queryForm.startTime"
                v-model:endTime="queryForm.endTime"
              />
            </dc-form-item>
            <!-- <dc-form-item name="roadAreaCode" label="路区代码">
              <a-select
                v-model:value="queryForm.stageList"
                placeholder="请选择"
                allow-clear
                mode="multiple"
                :options="clueAndcustomerPhaseEnum"
              />
            </dc-form-item> -->
            <dc-form-item name="requestContent" label="请求参数">
              <a-input v-model:value="queryForm.requestContent" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item name="responseContent" label="结果">
              <a-input v-model:value="queryForm.responseContent" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item name="requestType" label="类型">
              <a-select
                v-model:value="queryForm.requestType"
                placeholder="请选择"
                allow-clear
                :options="requestTypeEnum"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <ExportButton
            appId="cos_lbu"
            taskType="335"
            :search="queryForm"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column }">
          <template v-if="column.dataIndex === 'type'">
            推送智趣百川
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import { findByPage } from '@/api/yuntuSales/zhiQuLog'

const tableRef = ref()
const queryForm = reactive({
  requestSource: undefined,
  startTime: '',
  endTime: '',
  requestContent: '',
  responseContent: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await findByPage(params)
  callBack(res)
}

const requestSourceEnum = [
  {
    value: 'register',
    label: '官网注册'
  },
  {
    value: 'qrcode',
    label: '市场活码'
  },
  {
    value: 'icss',
    label: '工单系统'
  },
  {
    value: 'consultation',
    label: '官网咨询'
  },
  {
    value: 'lcos',
    label: 'LCOS'
  },
  {
    value: 'zhi_qu',
    label: '致趣百川'
  }
]

const requestTypeEnum = [
  {
    value: 0,
    label: '推送致趣百川'
  },
  {
    value: 1,
    label: '致趣百川投放'
  },
  {
    value: 2,
    label: '同步客户信息'
  },
  {
    value: 3,
    label: '同步流出公海线索信息'
  },
  {
    value: 4,
    label: '致趣百川二次投放'
  }
]

const columns = computed(() => [
  {
    title: '来源系统',
    dataIndex: 'requestSource',
    dicData: requestSourceEnum
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '类型',
    dataIndex: 'requestType',
    dicData: requestTypeEnum
  },
  {
    title: '请求参数',
    dataIndex: 'requestContent'
  },
  {
    title: '结果',
    dataIndex: 'responseContent'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuZhiQuLog' }
</script>

<style scoped></style>
